import {useEffect,useState,type RefObject} from 'react';
import {createPortal} from 'react-dom';

export function FirstAdSpotlight({target,onDismiss}:{target:RefObject<HTMLDivElement|null>;onDismiss:()=>void}){
 const [rect,setRect]=useState<DOMRect|null>(null);
 useEffect(()=>{
  const element=target.current;if(!element)return;
  element.scrollIntoView({block:'center',behavior:'instant'});
  const measure=()=>setRect(element.getBoundingClientRect());measure();
  const observer=new ResizeObserver(measure);observer.observe(element);
  window.addEventListener('resize',measure);window.addEventListener('scroll',measure,true);
  const escape=(event:KeyboardEvent)=>{if(event.key==='Escape')onDismiss();};window.addEventListener('keydown',escape);
  return()=>{observer.disconnect();window.removeEventListener('resize',measure);window.removeEventListener('scroll',measure,true);window.removeEventListener('keydown',escape);};
 },[target,onDismiss]);
 if(!rect)return null;
 const top=Math.max(0,rect.top-8),left=Math.max(0,rect.left-8),right=Math.min(window.innerWidth,rect.right+8),bottom=Math.min(window.innerHeight,rect.bottom+8);
 const panels=[{top:0,left:0,width:'100%',height:top},{top:bottom,left:0,width:'100%',bottom:0},{top,left:0,width:left,height:bottom-top},{top,left:right,right:0,height:bottom-top}];
 return createPortal(<div data-testid="first-ad-spotlight" aria-hidden="true" style={{position:'fixed',inset:0,zIndex:80,pointerEvents:'none'}}>
  {panels.map((style,index)=><div key={index} onClick={onDismiss} style={{position:'fixed',pointerEvents:'auto',zIndex:80,background:'rgba(40,35,43,.19)',backdropFilter:'blur(3px)',...style}}/>)}
  <div style={{position:'fixed',pointerEvents:'none',zIndex:81,top,left,width:right-left,height:bottom-top,borderRadius:22,boxShadow:'0 0 0 2px rgba(255,255,255,.8), 0 16px 50px rgba(0,0,0,.15)'}}/>
 </div>,document.body);
}
